module.exports = __webpack_public_path__ + "static/nagykovacsi-66c305579511eb86f4c76b291b080819.webp";